/* eslint-disable array-callback-return, no-useless-escape, func-names */
import FieldUtil from './FieldUtil';
import { parseString } from './stringHelper';

const enterpriseEmail = ['3shape.com'];
class Helper {
  static getColorPallete(index) {
    const colorList = [
      '#f44336',
      '#3f51b5',
      '#009688',
      '#e91e63',
      '#2196f3',
      '#357a38',
      '#9c27b0',
      '#0276aa',
      '#618833',
      '#b28704',
      '#673ab7',
      '#8f9a27',
      '#ff5722',
      '#b26a00',
      '#505336',
      '#683A33',
    ];

    return colorList[index % colorList.length];
  }

  static assignPartyColours(parties) {
    const sortedParties = parties.slice().sort((a, b) => {
      if (a.email < b.email) return -1;
      if (a.email > b.email) return 1;
      return 0;
    });
    const partyColours = {};
    sortedParties.map((p, i) => {
      partyColours[p.email] = Helper.getColorPallete(i);
    });
    return partyColours;
  }

  static generateShortName(username) {
    const parsedName = parseString(username);
    let acrnym = '';
    if (parsedName.length <= 2) {
      acrnym = parsedName;
    } else {
      const text = parsedName.split(' ');
      if (text.length > 1) {
        for (let i = 0, il = text.length; i < il; i++) {
          acrnym += text[i].substr(0, 1);
        }
        acrnym = acrnym.substring(0, 2);
      } else {
        acrnym = parsedName.substring(0, 2);
      }
    }

    return acrnym.toUpperCase();
  }

  /**
   * @typedef {Object} User
   * @property {String} fullName
   * @property {String} firstName
   * @property {String} lastName
   * @property {String} emailAddress
   */

  /**
   * generates full name of user
   * @param {User} user
   * @returns {string|string|string|*}
   */
  static generateFullName(user) {
    if (user.userFullName) return user.userFullName;
    if (user.firstName && user.lastName) return `${user.firstName} ${user.lastName}`;
    if (user.firstName) return user.firstName;
    if (user.lastName) return user.lastName;
    if (user.emailAddress) return user.emailAddress;
    return '';
  }

  static generateTimeAgoString(value, unit, suffix) {
    if (value < 60 && unit === 'second') {
      return 'just now.';
    } else if (value < 2 && unit === 'minute') {
      return 'just now.';
    } else if (value < 2 && unit === 'hour') {
      return 'an hour ago.';
    } else if (value < 2 && unit === 'day') {
      return 'a day ago.';
    } else if (value < 2 && unit === 'week') {
      return 'a week ago.';
    } else if (value < 2 && unit === 'month') {
      return 'a month ago.';
    } else if (value < 2 && unit === 'year') {
      return 'a year ago.';
    }
    return `${value} ${unit}s ${suffix}.`;
  }

  static checkRoleAndStatus(email, weight, process) {
    const nodes = process.nodes;
    const roles = {
      role: '',
      status: '',
    };
    const signer = nodes.filter(node => node.activity === 'SIGN' && node.user.emailAddress === email && node.weight === weight);
    if (signer.length > 0) {
      if (signer[0].status === 'COMPLETED') {
        roles.role = 'SIGNEE';
        roles.status = signer[0].status;
      } else {
        const reviewNodeStatus = nodes.filter(
          node => node.activity === 'REVIEW' && node.user.emailAddress === email && node.weight === weight
        );
        if (reviewNodeStatus[0].status === 'COMPLETED') {
          roles.role = 'SIGNEE';
          roles.status = signer[0].status;
        } else {
          roles.role = 'SIGNEE';
          roles.status = reviewNodeStatus[0].status;
        }
      }
    } else {
      const reviewer = nodes.filter(node => node.activity === 'REVIEW' && node.user.emailAddress === email && node.weight === weight);
      if (reviewer.length > 0) {
        roles.role = 'REVIEWER';
        roles.status = reviewer[0].status;
      } else {
        const sender = nodes.filter(node => node.activity === 'SEND' && node.user.emailAddress === email && node.weight === weight);
        if (sender[0].weight === 0 && sender[0].user.emailAddress === process.user.emailAddress) {
          roles.role = 'SENDER';
          roles.status = sender[0].status;
        } else {
          roles.role = 'RECEIVER';
          roles.status = sender[0].status;
        }
      }
    }
    return roles;
  }

  static getCardNodeDescription(key) {
    const message = {
      COMPLETED_SIGNEE: 'Has signed',
      COMPLETED_REVIEWER: 'Has approved',
      COMPLETED_SENDER: 'Has sent',
      COMPLETED_RECEIVER: 'Has received',
      IN_PROGRESS_SIGNEE: 'Has not yet signed',
      IN_PROGRESS_REVIEWER: 'Has not yet approved',
      IN_PROGRESS_SENDER: 'Has not yet sent',
      IN_PROGRESS_RECEIVER: 'Has not yet received',
      REJECTED: 'Has declined',
      WITHDRAWN: 'Has withdrawn',
    };

    return message[key];
  }

  static getNodeStatusWeight(key) {
    const weight = {
      COMPLETED: 0,
      REJECTED: 1,
      IN_PROGRESS: 3,
      NOT_SENT: 4,
    };

    return weight[key];
  }

  static isEnterpriseEmail(email) {
    const emailLowerCase = email.toLowerCase();
    const emailStringArray = emailLowerCase.split('@');
    const domainStringLocation = emailStringArray.length - 1;
    const finalDomain = emailStringArray[domainStringLocation];

    return enterpriseEmail.includes(finalDomain);
  }

  static getFieldsWeight(key) {
    const weight = {
      FREE_TEXT: 0,
      DATE: 1,
      CHECK_BOX: 2,
      NAME: 3,
      SIGNATURE: 4,
    };

    return weight[key];
  }

  static removeDuplicates(myArr, email, weight) {
    return myArr.filter(
      (obj, pos, arr) => arr.map(mapObj => mapObj[email] + mapObj[weight]).indexOf(obj[email] + obj[weight]) === pos
    );
  }

  static findUniqueParty(nodes, process) {
    const nodeModels = nodes.map(node => {
      const uniqueModel = {
        weight: 0,
        email: '',
        fullName: '',
        role: '',
        status: '',
        statusWeight: 0,
      };
      const roleObject = this.checkRoleAndStatus(node.user.emailAddress, node.weight, process);
      uniqueModel.weight = node.weight;
      uniqueModel.email = node.user.emailAddress;
      uniqueModel.fullName = `${node.user.firstName} ${node.user.lastName}`;
      uniqueModel.role = roleObject.role;
      uniqueModel.status = roleObject.status;
      uniqueModel.statusWeight = this.getNodeStatusWeight(roleObject.status);
      return uniqueModel;
    });
    const parties = this.removeDuplicates(nodeModels, 'email', 'weight');
    parties.sort((a, b) => {
      const statueWeightA = a.statusWeight;
      const statueWeightB = b.statusWeight;
      return Number.parseInt(statueWeightA) - Number.parseInt(statueWeightB);
    });
    return parties;
  }

  static isEmpty(obj) {
    if (obj === undefined || obj === null) return true;
    return Object.keys(obj).length === 0 && obj.constructor === Object;
  }

  static randomString(length) {
    const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    let result = '';
    for (let i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
    return result;
  }

  static isMobile() {
    let check = false;
    (function(a) {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
          a
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          a.substr(0, 4)
        )
      )
        check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
  }

  static isEdge() {
    return window.navigator.userAgent.indexOf('Edge') > -1;
  }

  static removeLastPathOf(url) {
    const arr = url.split('/');
    arr.pop();
    return arr.join('/');
  }

  static truncateString(str, minWidth, fontSetting) {
    if (str !== null && str && FieldUtil.getTextWidth(str, fontSetting) > minWidth) {
      for (let i = 1; i <= str.length; i++) {
        const truncatedStr = str.substring(0, str.length - i);
        if (FieldUtil.getTextWidth(truncatedStr, fontSetting) < minWidth) {
          return `${truncatedStr}...`;
        }
      }
    }
    return str;
  }

  static getLocalizedDateDifference = date => {
    const localDateOffset = new Date().getTimezoneOffset();
    const actionTime = new Date(date);
    actionTime.setMinutes(actionTime.getMinutes() - localDateOffset);
    return actionTime;
  };

  static validateEmailFormat(emailAddress) {
    const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regex.test(emailAddress);
  }

  static nonSenderRoles(roles) {
    return roles.filter(r => r.weight !== 0);
  }
} // end Class

export default Helper;
